import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Dropzone from 'react-dropzone';
import ReactCrop from 'react-image-crop';
import { connect } from 'react-redux';
import Immutable, { Map, List } from 'immutable'; // eslint-disable-line
import { Field, reduxForm, formValueSelector, change } from 'redux-form';

import immutableCreatorSelector from '../../selectors/immutableCreatorSelector';
import { avatarsSelector } from '../../reducers/avatars';
import { validateAndDispatch } from '../../helpers/form';
import { UserActions } from '../../actions/user';
import { currentUserSelector } from '../../reducers/users';
import config from '../../config';
if (__CLIENT__) {
  require('react-image-crop/dist/ReactCrop.css');
}

const avatarFormSelector = (state) => {
  const selector = formValueSelector('updateAvatar');
  return selector(state, 'avatar');
};

const avatarSelector = immutableCreatorSelector(
  [avatarFormSelector, currentUserSelector, avatarsSelector],
  (avatarForm, user, avatars) => ({
    fields: avatarForm,
    user,
    avatars,
    // initialValues: buildUserObject(user),
  })
);

@connect(avatarSelector)
@reduxForm({
  form: 'updateAvatar',
  destroyOnUnmount: false,
})
export default class Editor extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    handleSubmit: PropTypes.func,
    submitting: PropTypes.bool,
    reset: PropTypes.func,
    user: PropTypes.instanceOf(Map),
    avatars: PropTypes.instanceOf(Map),
    // image: PropTypes.string.isRequired
  }

  constructor(props) {
    super();
    const avatars = props.avatars || null;
    this.state = {
      uploadedFile: null,
      crop: {
        x: 0,
        y: 0,
        width: 30,
        aspect: 1,
      },
      croppedImage: null,
      userAvatar: (avatars) ? props.avatars.getIn([props.user.get('avatar_id'), 'path']) : null,
    };
  }

  // static getDerivedStateFromProps(nextProps, prevState) {
  //   // Store prevUserId in state so we can compare when props change.
  //   // Clear out any previously-loaded user data (so we don't render stale stuff).
  //   if (nextProps.userId !== prevState.prevUserId) {
  //     return {
  //       prevUserId: nextProps.userId,
  //       profileOrError: null,
  //     };
  //   }

  //   // No state update necessary
  //   return null;
  // }

  onDrop = (accepted) => {
    if (accepted.length) {
      this.setState({
        uploadedFile: accepted,
      });
    }
  }

  setCrop = (crop) => {
    this.cropImage(crop, 240, 240);
  }

  displayDropZone = () => (
    <div>
      <Dropzone
        onDrop={this.onDrop}
        multiple={false}
        accept="image/*"
        ref="dropzone"
      >
        <div style={{
          color: '#ccc',
          fontSize: 14,
          textAlign: 'center',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          height: 200,
        }}
        >
          <i className="fa fa-3x fa-upload" aria-hidden="true" style={{ display: 'block' }} />
          Select or drop an image to upload.
        </div>
      </Dropzone>
      <button
        type="button"
        onClick={this.openClick}
        className="btn btn-primary mt-2"
      >Browse...</button>
    </div>
  );

  openClick = () => {
    this.refs.dropzone.open();
  }

  loadImage = (src, cb) => new Promise((resolve, reject) => {
    let image = new Image();
    image.onload = async () => {
      await cb(image);
      resolve();
      image = null;
    };

    image.src = src;
  });

  scale = (options) => {
    let scale = options.scale ||
        Math.min(options.maxWidth / options.width, options.maxHeight / options.height);

    scale = Math.min(scale, options.maxScale || 1);

    return {
      scale,
      width: options.width * scale,
      height: options.height * scale,
    };
  };

  cropImage = (crop, maxWidth, maxHeight) => {
    const { dispatch } = this.props;
    const imgSrc = this.state.uploadedFile[0].preview;
    const cropAfterLoad = (loadedImg) => {
      const imageWidth = loadedImg.naturalWidth;
      const imageHeight = loadedImg.naturalHeight;

      const cropX = (crop.x / 100) * imageWidth;
      const cropY = (crop.y / 100) * imageHeight;

      const cropWidth = (crop.width / 100) * imageWidth;
      const cropHeight = (crop.height / 100) * imageHeight;

      let destWidth = cropWidth;
      let destHeight = cropHeight;

      if (maxWidth || maxHeight) {
        // Scale the crop.
        const scaledCrop = this.scale({
          width: cropWidth,
          height: cropHeight,
          maxWidth,
          maxHeight,
        });

        destWidth = scaledCrop.width;
        destHeight = scaledCrop.height;
      }

      const canvas = document.createElement('canvas');
      canvas.width = destWidth;
      canvas.height = destHeight;
      const ctx = canvas.getContext('2d');

      ctx.drawImage(loadedImg, cropX, cropY, cropWidth, cropHeight, 0, 0, destWidth, destHeight);
      // const canvasDataURL = canvas.toDataURL('image/jpeg');
      // console.log('dataURL', canvasDataURL);
      // dispatch(change('updateAvatar', 'avatar', canvasDataURL));
      // console.log('dataUrl', dataUrl);
      // this.setState({ croppedImage: dataUrl });
      return new Promise((resolve, reject) => {
        canvas.toBlob((blob) => {
          if (blob) {
            const url = URL.createObjectURL(blob);
            dispatch(change('updateAvatar', 'avatar', blob));
            this.setState({
              crop,
              croppedImage: url,
            });
            resolve(blob);
          } else {
            reject();
          }
        }, 'image/jpeg');
      });
    };

    return this.loadImage(
      imgSrc,
      cropAfterLoad.bind(this)
    );
  }

  // saveCrop = async () => {
  //   const { crop } = this.state;
  //   await this.cropImage(crop, 240, 240);
  //   // const croppedImage = this.state.croppedImage;
  //   // setTimeout(() => {
  //   //   const croppedImage = this.state.croppedImage;
  //   //   debugger;
  //   // }, 500);
  // }

  submit = (values, dispatch) => {
    const { reset, user } = this.props;
    const currentUserId = user.get('id');

    return validateAndDispatch(
      dispatch,
      UserActions.updateAvatar(currentUserId, values),
      {},
      values
    ).then(() => {
      reset();
      this.setState({ userAvatar: this.state.croppedImage });
    });
  }

  reset = () => {
    this.setState({
      uploadedFile: null,
      crop: {
        x: 0,
        y: 0,
        width: 30,
        aspect: 1,
      },
      croppedImage: null,
      userAvatar: null,
    });
  }

  deleteAvatar = () => {
    const { user, dispatch } = this.props;
    const currentUserId = user.get('id');
    const avatarId = user.get('avatar_id');
    this.reset();
    dispatch(UserActions.deleteAvatar(currentUserId, avatarId))
    // TODO: Race condition issue with firing this.reset() with then()
    // .then(() => {
    //   this.reset();
    // });
  }

  displayUserAvatar = () => {
    const { user, avatars } = this.props;
    const { userAvatar } = this.state;

    if (!userAvatar) {
      return null;
    }

    let imgFile;
    const userAvatarPath = avatars.getIn([user.get('avatar_id'), 'path']);

    if (userAvatarPath === userAvatar) {
      const ts = Date.now();
      imgFile = `//${config.avatarsHostname}/${userAvatar.split('/').pop()}?${ts}`;
    } else {
      imgFile = userAvatar;
    }

    // console.log('debug avatars', userAvatarPath, userAvatar, imgFile, this.state);

    return (
      <div>
        <img
          alt=""
          src={imgFile}
          style={{
            border: '1px solid #999',
            display: 'block',
          }}
        />
        <button
          type="button"
          onClick={this.reset}
          className="btn btn-outline-secondary mt-2"
        >Change Photo</button>
        <button
          type="button"
          onClick={this.deleteAvatar}
          className="btn btn-danger ml-2 mt-2"
        >Delete</button>
      </div>
    );
  }

  displayUploaded = () => {
    const {
      handleSubmit,
      submitting,
    } = this.props;

    const cropImg = (
      <div>
        <form onSubmit={handleSubmit(this.submit)}>
          <Field
            name="avatar"
            type="file"
            component={ReactCrop}
            src={this.state.uploadedFile[0].preview}
            crop={this.state.crop}
            onComplete={this.setCrop}
            onImageLoaded={this.setCrop}
            keepSelection
          />
          <button
            type="submit"
            // onClick={this.saveCrop}
            className="btn btn-primary mt-2 mr-2"
            disabled={submitting}
          >Crop and Save</button>
          <button
            type="button"
            onClick={this.reset}
            className="btn btn-outline-secondary mt-2"
          >Reset</button>
        </form>
      </div>
    );

    return cropImg;
  };

  renderDropZone = () => {
    if (this.state.userAvatar) {
      return this.displayUserAvatar();
    }

    const hasUploadedFile = (!this.state.uploadedFile || !this.state.uploadedFile.length);
    return (hasUploadedFile) ? this.displayDropZone() : this.displayUploaded();
  }

  render() {
    console.log('>>>> render');
    return (
      <div>
        <label>Photo</label>
        <div>
          {this.renderDropZone()}
        </div>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/UserProfile/AvatarEditor.js